<template>
  <div class="relative" ref="rootEl">
    <!-- Dropdown Button -->
    <button @click="toggleDropdown" type="button" :disabled="disabled"
      class="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed">
      {{ t('optionsdialog.Apply a theme') }}
      <i :class="['fas ml-2', isOpen ? 'fa-caret-up' : 'fa-caret-down']"></i>
    </button>

    <!-- Dropdown Menu -->
    <div v-if="isOpen"
      class="absolute z-10 mt-2 w-56 rounded-md shadow-lg bg-white dark:bg-stone-800 ring-1 ring-black ring-opacity-5 divide-y divide-stone-200 dark:divide-stone-700 overflow-auto max-h-[400px]">
      <div class="py-1">
        <!-- We're using v-for directly with keys on DOM elements instead of template tags -->
        <div v-for="themeCategoryName in Object.keys(colorThemeCategories)" :key="themeCategoryName">
          <!-- Category Header -->
          <div class="px-4 py-2 text-sm font-bold text-stone-900 dark:text-stone-100">
            {{ themeCategoryName }}
          </div>

          <!-- Theme Items -->
          <div v-for="themeName in Object.keys(colorThemeCategories[themeCategoryName])" :key="themeName">
            <button @click="selectTheme(themeCategoryName, themeName)"
              class="w-full text-left block px-4 py-2 text-sm text-stone-700 dark:text-stone-300 hover:bg-stone-100 dark:hover:bg-stone-700 focus:outline-none focus:bg-stone-100 dark:focus:bg-stone-700"
              role="menuitem">
              <div class="flex items-center">
                <span class="ml-2">{{ themeName }}</span>
                <div class="flex ml-2">
                  <div v-for="(color, colorIndex) in colorThemeCategories[themeCategoryName][themeName]"
                    :key="colorIndex" class="w-3 h-3 border border-stone-400 dark:border-stone-600 ml-1"
                    :style="{ backgroundColor: color }"></div>
                </div>
              </div>
            </button>
          </div>

          <!-- Separator -->
          <div class="border-t border-stone-200 dark:border-stone-700 my-1"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import colorThemeList from '@services/theme/colorThemeList.js';

const { t } = useI18n();
const emit = defineEmits(['set-color-theme']);
const props = defineProps({ disabled: Boolean });

const colorThemeCategories = colorThemeList;
const colorTheme = ref(null);
const isOpen = ref(false);
const rootEl = ref(null);

function toggleDropdown() {
  if (!props.disabled) {
    isOpen.value = !isOpen.value;
  }
}
function selectTheme(categoryName, themeName) {
  const newValue = `${categoryName}, ${themeName}`;
  colorTheme.value = newValue;

  const colors = colorThemeCategories[categoryName][themeName];
  const payload = { name: newValue, colors: colors };
  emit('set-color-theme', payload);
  isOpen.value = false;
}
function clickOutside(event) {
  if (isOpen.value && rootEl.value && !rootEl.value.contains(event.target)) {
    isOpen.value = false;
  }
}

onMounted(() => {
  document.addEventListener('click', clickOutside);
});
onBeforeUnmount(() => {
  document.removeEventListener('click', clickOutside);
});
</script>
